import BaseFieldsDrawer from "./BaseFieldsDrawer"
import $ from "jquery"
import makeRpcCall from "../../util/jquery_rpc"
import {ValidationErrors} from '../../panels/user/constants'
import {trim, isNotEmpty} from '../../atUtils'
import {isEnterPressed, isEscapePressed} from '../../atBrowserUtils'

export default class UserNameDrawer extends BaseFieldsDrawer {
    init(config) {
        super.init(config)
        this.disableValidation = config.disableValidation
        this.disableDuplicateUsernameCheck = config.disableDuplicateUsernameCheck
        this.disableEmptyUsernameCheck = config.disableEmptyUsernameCheck
        return this
    }

    initFields(accountSettings) {
        this.usernameCheckRpcCall = null
        this.usernameCheckTimeId = null
        var self = this
        this.usernameField = $(this.getElementByIdFunction("usernameField"))
        this.setValue(this.usernameField, "")
        this.usernameField.off()
        this.usernameField.placeholder()
        if (accountSettings.username)
            this.setValue(this.usernameField, accountSettings.username)
        var onUsernameFieldKeyUp = function() {
            this.keyPressed = false
            //noinspection JSPotentiallyInvalidUsageOfThis
            if ((!this.prevValue && !!this.value) || this.prevValue !== this.value) {
                this.prevValue = this.value
                if (!self.disableValidation) {
                    self.errors[ValidationErrors.USERNAME_EMPTY] = !self.disableEmptyUsernameCheck && self.usernameField.pVal().length === 0

                    if (!self.errors[ValidationErrors.USERNAME_EMPTY] && !self.disableDuplicateUsernameCheck)
                        self._checkUsernameDuplicates(this.value, accountSettings.id)
                    else {
                        self._cancelUsernameDuplicateCheck()
                        self.errors[ValidationErrors.USERNAME_DUPLICATE] = false
                    }
                }
                self.changeDetectedFunction(true)
                self.updateUICallback(self.errors)
            }
        }

        // see Bug 47490
        var onUsernameFieldBlur = function() {
            self.usernameField.pVal(trim(this.value))
            if (this.keyPressed || this.prevValue !== this.value) {
                onUsernameFieldKeyUp.call(this)
            }
            // check field on read only state
            if(!self.usernameField[0].readOnly) {
                self.usernameField.trigger('changed', [self.usernameField.pVal(), self.errors[ValidationErrors.USERNAME_DUPLICATE]])
            }
        }

        const onUsernameFieldKeyDown = (e) => {
            if (isEscapePressed(e) || isEnterPressed(e)) {
                this.usernameField.blur()
                e.stopPropagation()
            }
        }

        this.usernameField.blur(onUsernameFieldBlur)
        this.usernameField.keyup(onUsernameFieldKeyUp)
        this.usernameField.on("input", onUsernameFieldKeyUp)
        this.usernameField.keydown(onUsernameFieldKeyDown)

        $(this.getElementByIdFunction("usernameColumn")).show()
    }

    getObjectValues() {
        return {
            username: this.usernameField.pVal()
        }
    }

    _cancelUsernameDuplicateCheck() {
        clearTimeout(this.usernameCheckTimeId)
        if (this.usernameCheckRpcCall)
            this.usernameCheckRpcCall.abort()
        this.usernameCheckRpcCall = null
    }

    cancelAllServerSideChecks() {
        this._cancelUsernameDuplicateCheck()
    }

    _checkUsernameDuplicates(username, id) {
        this._cancelUsernameDuplicateCheck()
        if (!username || !isNotEmpty(username)) {
            this._checkUsernameDuplicatesCallback(false)
        }
        else {
            var self = this
            this.usernameCheckTimeId = setTimeout(function() { self._doCheckUsernameDuplicatesRPCCall(trim(username), id) }, 200)
        }
    }

    _doCheckUsernameDuplicatesRPCCall(username, id) {
        var self = this
        this.usernameCheckRpcCall = makeRpcCall(
            "UserManagementService.checkUsernameExists",
            [username, id],
            function(result) {self._checkUsernameDuplicatesCallback(result) },
            this.checkUsernameErrorHandler
        )
    }

    _checkUsernameDuplicatesCallback(result) {
        if (result) {
            this.errors[ValidationErrors.USERNAME_EMPTY] = false
        }
        this.errors[ValidationErrors.USERNAME_DUPLICATE] = result
        this.validationDetectedCallback()
        this.updateUICallback(this.errors)
    }

    validateFields(oldErrors) {
        if (this.usernameField.pVal().length === 0) {
            this.errors[ValidationErrors.USERNAME_EMPTY] = true
            this.errors[ValidationErrors.USERNAME_DUPLICATE] = false
        }
        else
            this.errors[ValidationErrors.USERNAME_DUPLICATE] = oldErrors[ValidationErrors.USERNAME_DUPLICATE]
        return this.errors
    }

    setDuplicateNameError() {
        this.errors[ValidationErrors.USERNAME_EMPTY] = false
        this.errors[ValidationErrors.USERNAME_DUPLICATE] = true
        return this.errors
    }

    hasErrors() {
        return this.errors[ValidationErrors.USERNAME_EMPTY] || this.errors[ValidationErrors.USERNAME_DUPLICATE]
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/UserNameDrawer.js